import React from 'react';
import { Disclosure } from '@headlessui/react';
import { PlusIcon } from 'lucide-react';
import { 
  FAQContainer, 
  FAQTitle, 
  FAQItemContainer, 
  FAQQuestionButton, 
  FAQAnswerPanel 
} from './styled';

const FAQ = ({ title, faqItems }) => {
  const formatAnswer = (answer) => {
    // Convert newlines to <br /> tags
    let formattedAnswer = answer.replace(/\n/g, '<br />');
    
    // Convert bullet points to HTML list items
    formattedAnswer = formattedAnswer.replace(/•\s(.*?)(?=<br \/>|$)/g, '<li>$1</li>');
    
    // Wrap lists in <ul> tags
    if (formattedAnswer.includes('<li>')) {
      formattedAnswer = '<ul>' + formattedAnswer + '</ul>';
    }
    
    return formattedAnswer;
  };

  return (
    <FAQContainer>
      <FAQTitle>{title}</FAQTitle>
      {faqItems.map((item, index) => (
        <Disclosure key={index} as="div">
          {({ open }) => (
            <FAQItemContainer>
              <Disclosure.Button as={FAQQuestionButton}>
                <span>{item.question}</span>
                <PlusIcon
                  className={`${
                    open ? 'transform rotate-45' : ''
                  } w-5 h-5 text-white transition-transform duration-200`}
                />
              </Disclosure.Button>
              <Disclosure.Panel as={FAQAnswerPanel}>
                <div dangerouslySetInnerHTML={{ __html: formatAnswer(item.answer) }} />
              </Disclosure.Panel>
            </FAQItemContainer>
          )}
        </Disclosure>
      ))}
    </FAQContainer>
  );
};

export default FAQ;